import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, List } from '@pella/sash-framework';
import { CTA } from '../../../../';

import BackBtn from '../../back-button';

const ProductMenu = ({ data, parent }) => (
	<List
		bullets='none'
		className='absolute -right-full top-0 z-[11] h-[calc(100vh-59px)] w-full overflow-hidden bg-white motion-safe:transition-all motion-safe:duration-500 sm:h-[calc(100vh-61px)] md:-right-80 md:w-80'
	>
		<BackBtn title={parent} />

		{data?.[0] &&
			data.map((sec, index) => (
				<li key={index}>
					<Collapse hasIcon={false}>
						<Collapse.Trigger
							activeIcon={null}
							inactiveIcon={null}
							className='!py-3 px-4 text-base font-semibold uppercase tracking-2px'
						>
							<div dangerouslySetInnerHTML={{ __html: sec.section_heading?.[0]?.cta_title }} />
						</Collapse.Trigger>

						<Collapse.Content className='border-t border-t-gray-15 bg-gray-5 !p-5'>
							<List
								bullets='none'
								className='pal-mobileNav-LinkList'
							>
								{sec.section_heading?.[0] && (
									<li className='text-center'>
										<CTA
											data={sec.section_heading[0]}
											className='text-base font-semibold no-underline hover:text-blue focus:text-blue'
										/>
									</li>
								)}

								{sec.subnav?.[0] &&
									sec.subnav.map((links, index) => (
										<React.Fragment key={index}>
											<li
												className='mb-0.5 mt-3'
												dangerouslySetInnerHTML={{ __html: links.heading }}
											/>

											{links.ctas?.[0] &&
												links.ctas.map((link, index) => (
													<li key={index}>
														<CTA
															data={link}
															className='inline-block py-0.5 pl-2 no-underline'
														/>
													</li>
												))}
										</React.Fragment>
									))}
							</List>
						</Collapse.Content>
					</Collapse>
				</li>
			))}
	</List>
);

ProductMenu.propTypes = {
	data: PropTypes.array,
	parent: PropTypes.string,
};

export default ProductMenu;
